import { Injectable } from '@angular/core';

import moment from 'moment-timezone';
import { Moment } from 'moment-timezone';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({providedIn: 'root'})
export class DateTimeService {
  momentToNgbDate(date: Moment): NgbDateStruct {
    return {
      year: date.get('year'),
      month: date.get('month') + 1,
      day: date.get('date'),
    };
  }

  ngbDateToMoment({year, month, day}: NgbDateStruct, timezone: string): Moment {
    return moment.tz(timezone).set({
      year,
      month: month - 1,
      date: day,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    });
  }

  roundingMinutes(timestamp: number, roundingTo, timezone: string) {
    const time = moment.tz(timestamp, timezone);
    const minutes = time.get('minutes');
    const delta = minutes >= roundingTo ? minutes % roundingTo : minutes;

    return time.set('minutes', minutes - delta);
  }

  setTimeToDate(date: Moment, time: string, timezone: string) {
    const selectedTime = moment.tz(time, 'h:mm a', timezone);

    return date.set({
      hour: selectedTime.get('hour'),
      minute: selectedTime.get('minute'),
      second: 0,
      millisecond: 0,
    });
  }

  timestampToISOString(time: number, timezone: string): string {
    return moment.tz(time, timezone).format('YYYY-MM-DDTHH:mm:ss');
  }

  cutOffsetISOString(time: string): string {
    return moment(time).format('YYYY-MM-DDTHH:mm:ss');
  }

  ISOToMoment(time: string, timezone: string): Moment {
    return moment.tz(this.cutOffsetISOString(time), timezone);
  }
}
